import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { UserResponse } from '@/shared/api';
import { Button } from '@/shared/components';
import { UserInvitationLinkDialog } from './UserInvitationLinkDialog';

export function UserInvitationAction({ user }: { user: UserResponse }) {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation('invitations');
  return (
    <>
      <Button
        type="button"
        variant="ghost"
        className="border-line min-h-11 w-full whitespace-normal border"
        onClick={() => setOpen(true)}
      >
        {t('action')}
      </Button>
      {open && <UserInvitationLinkDialog user={user} open onClose={() => setOpen(false)} />}
    </>
  );
}
